import Icon from '@material-ui/icons/CloudDownload';
import downloadCreate from './DownloadCreate'


export default {
    create: downloadCreate,
    icon: Icon
};
